import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer: React.FC = () => {
  const location = useLocation();
  const isHomepage = location.pathname === '/';

  return (
    <div id="site-footer" className={isHomepage ? 'bg-[#fafafa]' : 'border-t border-border bg-background'}>
      <div className="max-w-[1440px] mx-auto px-4 md:px-[160px] py-8 flex flex-col-reverse md:flex-row items-center justify-between gap-8 md:gap-0">
        <p className="font-body font-medium text-sm text-foreground text-center md:text-left">
          &copy;ByLLMs. All Rights Reserved. MMXXVI
        </p>

        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10 font-body font-medium text-sm text-foreground">
          <a
            href="mailto:support@byllms.com"
            className="hover:opacity-70 transition-opacity"
          >
            Contact Us
          </a>
          <Link to="/privacy" className="hover:opacity-70 transition-opacity">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:opacity-70 transition-opacity">
            Service Terms
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Footer;
